import type {RunningExperiments} from '@wix/document-services-types'

const transformedExperimentsCache = new WeakMap<RunningExperiments, RunningExperiments>()

function getRunningExperiments(context?: Context): RunningExperiments {
    const model = (context && (context.rendererModel || context.editorModel)) || {runningExperiments: {}}
    const {runningExperiments = {}} = model
    return runningExperiments
}

function transformRunningExperiments(runningExperiments: RunningExperiments): RunningExperiments {
    return Object.keys(runningExperiments).reduce((acc, key) => {
        acc[key.toLowerCase()] = runningExperiments[key]
        return acc
    }, Object.create(null))
}

function getValue(name: string, context: Context): string {
    const runningExperiments = getRunningExperiments(context)
    const value = runningExperiments[name]
    if (value !== undefined) {
        return value
    }

    let transformedExperiments = transformedExperimentsCache.get(runningExperiments)
    if (!transformedExperiments) {
        transformedExperiments = transformRunningExperiments(runningExperiments)
        transformedExperimentsCache.set(runningExperiments, transformedExperiments)
    }
    return transformedExperiments[name.toLowerCase()]
}

function isMultiValueExperimentOpen(name: string, context: Context): boolean {
    const value = getValue(name, context)
    return !!(value && value !== 'old' && value !== 'false')
}

export interface ExpContext {
    runningExperiments: RunningExperiments
}

export interface Context {
    rendererModel?: ExpContext
    editorModel?: ExpContext
}

export interface Experiment {
    getRunningExperiments(override?: Context): RunningExperiments
    getValue(name: string, override?: Context): string
    isMultiValueExperimentOpen(name: string, override?: Context): boolean
    isOpen(name: string, context?: Context): boolean
}

export const experiment: Experiment = {
    getRunningExperiments,
    getValue,
    isMultiValueExperimentOpen,
    isOpen: isMultiValueExperimentOpen
}
